const FORM_IFRAME_ID = "frame_W_IabWWlBYkHA2SpQEDHiw"

class LeaseCalculator {
    constructor(config) {
        this.config = config;
        this.selectedLease = null;
        this.equipmentValue = 0;
        this.leaseTotals = {
            leaseName: '',
            leaseLength: 0,
            weeklyPayment: 0,
            monthlyPayments: 0,
            totalCost: 0,
            taxRelief: 0,
            netCost: 0,
        };

        this.initialize();
    }

    initialize() {
        const valueInput = document.querySelector('[data-element="equipment-value"]');
        if (valueInput) {
            valueInput.value = 1000;
            this.equipmentValue = 1000;
        }
        
        this.setupEventListeners();
        this.selectFirstLease();
        this.updateFinanceTotals();
    }

    setupEventListeners() {
        const valueInput = document.querySelector('[data-element="equipment-value"]');
        if (valueInput) {
            valueInput.addEventListener('change', (e) => {
                if (e.target.value === "" || isNaN(Number(e.target.value))) {
                    this.showValidationError(
                        '<p>Please enter numbers only for the equipment value.</p>'
                    );
                    this.equipmentValue = 0;
                } else {
                    this.equipmentValue = parseFloat(e.target.value);
                }

                const maxValue = Number(e.target.max);
                if (maxValue && this.equipmentValue > maxValue) {
                    this.showValidationError(
                        `<p><strong>Maximum value allowed:</strong> £${maxValue.toLocaleString()}</p>
                        <p>Please enter a value of £${maxValue.toLocaleString()} or less to proceed with your finance application.</p>`
                    );
                    this.equipmentValue = 0;
                }
                this.updateFinanceTotals();
            });
        }

        // Lease option clicks
        document.querySelectorAll('[data-lease-option]').forEach(option => {
            option.addEventListener('click', (e) => this.handleLeaseSelect(e));
        });
    }

    selectFirstLease() {
        if (this.config.options?.length) {
            this.selectedLease = this.config.options[0];
            this.updateActiveLease(this.selectedLease);
        }
    }

    handleLeaseSelect(event) {
        event.preventDefault();
        const leaseId = event.currentTarget.dataset.leaseId;
        const lease = this.config.options[parseInt(leaseId, 10)];
        if (lease) {
            this.selectedLease = lease;
            this.updateActiveLease(lease);
            this.updateFinanceTotals();
        }
    }

    updateActiveLease(lease) {
        // Remove active class from all options
        document.querySelectorAll('[data-lease-option]').forEach(option => {
            option.classList.remove('active');
        });

        // Add active class to selected option
        const targetOption = document.querySelector(`.lease-duration-option-${lease.leaseId}`);
        if (targetOption) targetOption.classList.add('active');
    }

    updateFinanceTotals() {
        if (!this.selectedLease || !this.equipmentValue) return;

        // Calculate values
        const monthly = this.equipmentValue * this.selectedLease.first_payment_amount;
        const weekly = (monthly * 12) / 52;
        const total = monthly * this.selectedLease.term_length;
        const taxRelief = total * this.config.tax_relief;

        // Update totals
        this.leaseTotals = {
            leaseName: this.selectedLease.name,
            leaseLength: this.selectedLease.term_length,
            weeklyPayment: weekly,
            monthlyPayments: monthly,
            totalCost: total,
            taxRelief: taxRelief,
            netCost: total - taxRelief,
        };

        this.updateUI();

        // Trigger validation check after updating UI
        if (!this.validateValue()) {
            this.showValidationError();
        } else {
            this.hideValidationError();
        }
    }

    updateUI() {
        // Update displayed values in DOM
        this.updateElement('lease-name', this.leaseTotals.leaseName);
        this.updateElement('lease-length', this.leaseTotals.leaseLength);
        this.updateElement('weekly-payment', this.leaseTotals.weeklyPayment, true);
        this.updateElement('monthly-payments', this.leaseTotals.monthlyPayments, true);
        this.updateElement('total-cost', this.leaseTotals.totalCost, true);
        this.updateElement('tax-relief', this.leaseTotals.taxRelief, true);
        this.updateElement('net-cost', this.leaseTotals.netCost, true);
        this.updateElement('equipment-value', this.equipmentValue, true);
    }

    updateElement(elementId, value, isCurrency = false) {
        const elements = document.querySelectorAll(`[data-element="${elementId}"]`)
        const formattedValue = isCurrency ? this.formatMoney(value) : value;

        for (const element of elements) {
            if (element) {
                element[element.tagName === 'input' ? 'value' : 'textContent'] = formattedValue
            }
        }

        this.updateForm(elementId, formattedValue);
    }

    formatMoney(value) {
        // window.Shopify.formatMoney < This only uses toFixed, so will always round down.
        // This should round correctly, for example 36.345 should show as 36.35.
        return (Math.round(value * 100) / 100).toFixed(2)
    }

    validateValue() {
        return this.equipmentValue >= this.config.minimum_value;
    }

    showValidationError(html = null) {
        const existingError = document.querySelector('.furniture-calc-validation-error');
        if (existingError) return;

        const errorDiv = document.createElement('div');
        errorDiv.className = 'furniture-calc-validation-error';
        errorDiv.innerHTML = html || `
            <p><strong>Minimum value required:</strong> £${this.config.minimum_value.toLocaleString()}</p>
            <p>Please enter a value of £${this.config.minimum_value.toLocaleString()} or more to proceed with your finance application.</p>
        `;

        const formContainer = document.querySelector('.quick-lease-calculator-wrapper');
        if (formContainer) formContainer.prepend(errorDiv);
    }

    hideValidationError() {
        const errorDiv = document.querySelector('.furniture-calc-validation-error');
        if (errorDiv) errorDiv.remove();
    }

    updateForm(elementId, value) {
        const iframe = document.getElementById(FORM_IFRAME_ID);
        if (!iframe) throw new Error('Form iframe not found');

        if (!this.validateValue()) {
            iframe.contentWindow.postMessage({
                type: 'disable-submit-furniture-calc'
            }, '*');
            this.showValidationError();
            return;
        }

        this.hideValidationError();
        iframe.contentWindow.postMessage({
            type: 'enable-submit-furniture-calc'
        }, '*');
        iframe.contentWindow.postMessage({
            type: 'update-input-furniture-calc',
            inputName: elementId,
            value: value,
        }, '*');
    }

    // In HulkApps > Form Integration > Advanced > Advanced JS
    // static __formListener() {
    //     const messageHandlers = {
    //         'update-input-furniture-calc': (data) => {
    //             const input = document.querySelector(`input[name="${data.inputName}"]`);
    //             if (input) input.value = data.value;
    //         },
    //         'disable-submit-furniture-calc': () => {
    //             const submitButton = document.querySelector('button[type="submit"]');
    //             if (submitButton) {
    //                 submitButton.disabled = true;
    //                 submitButton.style.opacity = '0.5';
    //                 submitButton.style.cursor = 'not-allowed';
    //             }
    //         },
    //         'enable-submit-furniture-calc': () => {
    //             const submitButton = document.querySelector('button[type="submit"]');
    //             if (submitButton) {
    //                 submitButton.disabled = false;
    //                 submitButton.style.opacity = '1';
    //                 submitButton.style.cursor = 'pointer';
    //             }
    //         }
    //     };
    //
    //     window.addEventListener('message', (event) => {
    //         const handler = messageHandlers[event.data.type];
    //         if (handler) handler(event.data);
    //     });
    // }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    new LeaseCalculator(window.leaseCalculator);
});
